<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
<p-fieldset>

    <ng-template pTemplate="header">{{lbl_workshop}}</ng-template>
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="redirectWorkShop()"></button>
        </ng-template>
    </p-toolbar>

    <!-- Main Card -->
    <div class="card">
        <!-- Grid -->
        <div class="p-grid">

            <!-- 1st Section -->
            <div class="p-col-12 p-md-6">
                <div class="p-fluid">

                    <!-- <pre>{{ security | json}}</pre> -->

                    <!-- State  -->
                    <div class="p-col-12">
                        <label for="listState">{{lbl_state}} <span style="color:red"> (*)</span></label>
                        <p-dropdown [options]="listState" [(ngModel)]="selectedState"
                            placeholder="{{lbl_select}} {{lbl_state}}" optionLabel="descrip" [showClear]="true"
                            [filter]="device == '2' ? false : true" (onChange)="getChurches()"
                            [disabled]="canEditDisabled"></p-dropdown>
                    </div>

                    <!-- Church -->
                    <div class="p-col-12">
                        <label for="selectedParis">{{lbl_church_name_}} <span style="color:red"> (*)</span></label>
                        <p-autoComplete panelStyleClass="panelTest" class="mdb-autocomplete" [style]="{'width':'100%'}"
                            [inputStyle]="{'width':'100%'}" id="selectedParis" [(ngModel)]="selectedParis"
                            [suggestions]="filteredChurchs" (completeMethod)="filterChurch($event)" field="name"
                            [minLength]="1" [dropdown]="true" autoWidth="false"
                            [disabled]="canEditDisabled"></p-autoComplete>
                    </div>

                    <!-- Time -->
                    <div class="p-col-12">
                        <div class=" p-fluid p-formgrid p-grid church_field">
                            <div class="p-col-12 p-md-6">
                                <label for="anioPeriod">{{lbl_year}} <span style="color:red"> (*)</span></label>
                                <p-inputNumber [(ngModel)]="anioPeriod" inputId="withoutgrouping" [useGrouping]="false"
                                    [showButtons]="true" [min]="currentYear-3" [max]="currentYear+3"
                                    [disabled]="this.security?.levelId === undefined || this.security?.levelId === null|| this.security.levelId != 'Z'"></p-inputNumber>
                            </div>
                            <div class="p-col-12 p-md-6">
                                <label for="numberPeriodo">{{lbl_period}} <span style="color:red">
                                        (*)</span></label>
                                <p-inputNumber [(ngModel)]="numberPeriodo" inputId="minmax" mode="decimal" [min]="1"
                                    [max]="2" [showButtons]="true"
                                    [disabled]="this.security?.levelId === undefined || this.security?.levelId === null|| this.security.levelId != 'Z'"></p-inputNumber>
                            </div>
                        </div>
                    </div>

                    <!-- Workshop List -->
                    <div class="p-col-12">
                        <label for="listWorkshopType">{{lbl_type}} {{lbl_workshop}} <span style="color:red">
                                (*)</span></label>
                        <p-dropdown [options]="listWorkshopType" [(ngModel)]="selectedWorkshopType"
                            placeholder="{{lbl_select}} {{lbl_type}} {{lbl_workshop}}" optionLabel="wsName"
                            [showClear]="true" (onChange)="checkMateLabel()"
                            [disabled]="canEditDisabled || (this.workShopDetail && this.workShopDetail.f0 && (this.workShopDetail.f0.serTyp=='16' || this.workShopDetail.f0.serTyp=='17' || this.workShopDetail.f0.serTyp=='18'))"></p-dropdown>
                    </div>

                    <!-- Language -->
                    <div class="p-col-12">
                        <label for="listLanguage">{{lbl_language}} <span style="color:red"> (*)</span></label>
                        <p-dropdown [options]="listLanguage" [(ngModel)]="selectedLanguage"
                            placeholder="{{lbl_select}} {{lbl_language}}" optionLabel="value" [showClear]="true"
                            [disabled]="canEditDisabled"></p-dropdown>
                    </div>

                    <!-- 1st Guide  -->
                    <div class="p-col-12">
                        <label for="listGuidesStore"> {{lbl_guide_imparts}}:
                            <!--    {{this.typeRedirect == 'WM' ? 'Guía que imparte_' : lbl_guide }}: -->
                            <span style="color:red"> (*) </span></label>
                        <p-dropdown [options]="listGuidesStoreActiv" [(ngModel)]="selectedGuideStore"
                            placeholder="{{lbl_select}} 1° {{lbl_guide_imparts}}" optionLabel="fullName"
                            [filter]="device == '2' ? false : true"
                            [readonly]="this.typeRedirect == 'WM' || this.security.levelId!='G' ? false : true"
                            [disabled]="canEditDisabled"></p-dropdown>
                    </div>

                    <!-- 2nd Guide  -->
                    <div class="p-col-12">
                        <label *ngIf="visibleMateGuide && selectedWorkshopType.wsId != '06'" for="listGuidesStore2">
                            {{lbl_mate_guide_refunding}}:
                            <!--{{this.typeRedirect == 'WM' ? 'Guía que acompaña(Ver refundación)' :
                            lbl_mate_guide_refunding}}:-->
                        </label>
                        <label *ngIf="visibleMateGuide && selectedWorkshopType.wsId == '06'" for="listGuidesStore2">
                            {{lbl_husband_wife}}:
                        </label>
                        <p-dropdown *ngIf="visibleMateGuide" [options]="listGuidesStore2"
                            [(ngModel)]="selectedGuideStore2" placeholder="{{lbl_select}} 2° {{lbl_guide_imparts}}"
                            optionLabel="fullName" [showClear]="true"
                            [filter]="device == '2' ? false : true"></p-dropdown>
                    </div>

                    <!-- 3er Guide  -->
                    <div class="p-col-12">
                        <label *ngIf="!visibleMateGuide" for="listGuidesStore3">
                            {{lbl_partner_guide}}:</label>
                        <p-dropdown *ngIf="!visibleMateGuide" [options]="listGuidesStore3"
                            [(ngModel)]="selectedGuideStore3" placeholder="{{lbl_select}} 2° {{lbl_partner_guide}}"
                            optionLabel="fullName" [showClear]="true"
                            [filter]="device == '2' ? false : true"></p-dropdown>
                    </div>
                </div>
            </div>

            <!-- 2nd Section -->
            <div class="p-col-12 p-md-6">
                <div class="p-fluid">

                    <div class="p-col-12 ">
                        <div class=" p-fluid p-formgrid p-grid">
                            <div class="p-col-12 p-md-6">
                                <label for="startDate">{{lbl_starting_date}} <span style="color:red">
                                        (*)</span></label>
                                <p-calendar [(ngModel)]="startDate" [touchUI]="true" [readonlyInput]="true"
                                    inputId="touchui" dateFormat="yy-mm-dd" (onSelect)="onSelectInitialDate()"
                                    (onFocus)="onUpdateMinMaxByPeriodYear()" [disabled]="canEditDisabled"
                                    [maxDate]="maxDate" [minDate]="minDate"></p-calendar>
                            </div>
                            <div class="p-col-12 p-md-6">
                                <label for="date1">{{lbl_ending_date}}</label>
                                <p-calendar [(ngModel)]="endDate" [touchUI]="true" [readonlyInput]="true"
                                    [disabled]="canEditDisabled" inputId="touchui" dateFormat="yy-mm-dd"
                                    [maxDate]="maxDate" [minDate]="startDate"></p-calendar>
                            </div>
                        </div>
                    </div>

                    <div class="p-col-12">
                        <label for="sessNum">{{lbl_number}} {{lbl_sessions}}</label>
                        <input id="disabled-input" [(ngModel)]="sessNum" type="text" pInputText [disabled]="true" />
                    </div>


                    <div class="p-col-12">
                        <label for="sessDay">{{lbl_day}} </label>
                        <p-dropdown [options]="listWeekDays" [(ngModel)]="selectedWeekDay" optionLabel="descrip"
                            placeholder="Seleccione un día" [showClear]="true"></p-dropdown>
                    </div>

                    <!-- Start and Finish day 
                                                    <input type="text" pInputText [(ngModel)]="startTime" pInputMask="99:99"
                                    placeholder="HH:MM" pattern="^([01]?[0-9]|2[0-3]):[0-5][0-9]$">

                    -->
                    <div class="p-col-12">
                        <div class=" p-fluid p-formgrid p-grid church_field">
                            <div class="p-col-12 p-md-6">
                                <label for="startTime">{{lbl_starting_time}} <span style="color:red">
                                        (*)</span></label>
                                <p-calendar [(ngModel)]="startTime" [timeOnly]="true" inputId="timeonly"
                                    (onSelect)="onSelectInitialTime()" (onClose)="onSelectInitialTime()"></p-calendar>
                            </div>
                            <div class="p-col-12 p-md-6">
                                <label for="endTime">{{lbl_ending_time}}</label>
                                <p-calendar [(ngModel)]="endTime" [timeOnly]="true" inputId="timeonly"
                                    [disabled]="true"></p-calendar>
                            </div>
                            <div class="p-col-12 p-md-6">
                                <label for="partici1s2s">{{lbl_participants_1st}}</label>
                                <label *ngIf="!visiblePartici1s2s"> {{partici1s2s}}</label>
                                <p-inputNumber [(ngModel)]="partici1s2s" mode="decimal" inputId="withoutgrouping"
                                    [useGrouping]="false" [min]="0" [max]="999" *ngIf="visiblePartici1s2s">
                                </p-inputNumber>
                            </div>
                            <div class="p-col-12 p-md-6">
                                <label for="particiDes">{{lbl_lastSessionPart}}</label>
                                <label *ngIf="!visibleparticiDes"> {{particiDes}}</label>
                                <p-inputNumber [(ngModel)]="particiDes" mode="decimal" inputId="withoutgrouping"
                                    [useGrouping]="false" [min]="0" [max]="999" *ngIf="visibleparticiDes">
                                </p-inputNumber>
                            </div>
                        </div>
                    </div>

                    <!-- Comments -->
                    <div class="p-col-12">
                        <label for="comments">{{lbl_comments}}</label>
                        <textarea [(ngModel)]="comments" rows="5" cols="30" pInputTextarea autoResize="autoResize"
                            maxlength="150" #myInput></textarea>
                        <label class="nopadding clrlbl">{{myInput.value.length}} / 150 </label>
                    </div>

                    <div class="p-col-12">

                    </div>
                </div>
            </div>
        </div>

        <div class="p-grid">
            <div class="p-col-12 p-md-6"></div>
            <div class="p-col-12 p-md-6">
                <!-- Buttons -->
                <div class="p-col-12">
                    <div class=" p-fluid p-formgrid p-grid church_field">
                        <div class="p-col-12 p-md-4"></div>
                        <div class="p-col-12 p-md-4">
                            <div class="p-field">
                                <button pButton pRipple type="button" icon="pi pi-plus" label="{{lbl_save}}"
                                    [disabled]="this.workShopDetail  && this.workShopDetail.f0 && this.workShopDetail.f0.status=='C'? true : false"
                                    class="p-button-raised p-button-success" (click)="saveUpdateWorkShop()"></button>

                            </div>
                        </div>
                        <div class="p-col-12 p-md-4">
                            <div class="p-field">
                                <button pButton pRipple type="button" icon="pi pi-trash" label="{{lbl_delete}}"
                                    class="p-mr-2 p-mb-2 p-button-raised p-button-danger" (click)="deleteWorkShop()"
                                    [disabled]="this.workShopDetail  && this.workShopDetail.f0 && (this.workShopDetail.f0.status=='C' || (this.workShopDetail.f0.serTyp=='16' || this.workShopDetail.f0.serTyp=='17' || this.workShopDetail.f0.serTyp=='18'))? true : false"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-fieldset>